<div class="modal-header">
  <h5 class="" id="modal-title">
    ELEK Cable Pro Web - User Login
  </h5>
  <button type="button" class="close" aria-describedby="modal-title"
    (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <app-login *ngIf="step == 1" [isPopup]="true" [isWebFacing]="true"></app-login>
  <send-two-factor-code *ngIf="step == 2" [isPopup]="true" [isWebFacing]="true" (stepUpdate)="updateStep($event)"></send-two-factor-code>
  <validate-two-factor-code *ngIf="step == 3" [isPopup]="true" [isWebFacing]="true" (stepUpdate)="updateStep($event)"></validate-two-factor-code>
  <app-reset-password *ngIf="step == 4" [model]="model" [isPopup]="true" [isWebFacing]="true" (stepUpdate)="updateStep($event)"></app-reset-password>
</div>